import { render, staticRenderFns } from "./MsalLoggedOnComponent.vue?vue&type=template&id=a10f663c&scoped=true&"
import script from "./MsalLoggedOnComponent.vue?vue&type=script&lang=ts&"
export * from "./MsalLoggedOnComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10f663c",
  null
  
)

export default component.exports